import React from 'react';
import Visionn from './Visionn';
import Testimonialsabout from './TestimonialsAbhout';
import { Helmet } from 'react-helmet';

const About = () => {

    
const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Pune to Mumbai Cab",
    "description": "Book your comfortable Pune to Mumbai cab for a smooth and hassle-free journey. Choose from one-way, round trip, and group travel options with both affordable and luxury cabs.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "450"
    }
  };
    return (

       <>



          <Helmet>
              <title>Pune to Mumbai Cab | S9 Travels | Contact: +91 8850328441</title>
              <meta 
                name="description" 
                content="Book a reliable cab for your Pune to Mumbai journey. Affordable and luxury cabs available for one-way, round-trip, and group travel services." 
              />
              {/* Inject JSON-LD Schema */}
              <script type="application/ld+json">
                {JSON.stringify(productSchema)}
              </script>
            </Helmet>
        <section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>About us</h1>
        </div>
      </div>
    </section>

    
        <section className="about-section ">
            <div className="pattern-layer" style={{ backgroundImage: 'url(/images/shape/shape-1.png)' }}></div>
            <div className="auto-container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12 col-sm-12 content-column">
                        <div className="content_block_one">
                            <div className="content-box mr_60">
                                <div className="sec-title mb_30">
                                    <span className="sub-title">About us</span>
                                    <h2>Planning a trip with S9 Travels should be an exciting adventure!</h2>
                                </div>
                                <div className="text-box mb_35">
                                    <p>Since its inception, S9 Travels has been dedicated to providing exceptional, reliable, and comfortable travel experiences to all its customers. With a fleet of well-maintained vehicles, ranging from economical compact cars to luxurious SUVs and sedans, and a team of professional, courteous drivers, we ensure that every journey you take is safe, smooth, and enjoyable.<br/><br/>

Whether you need a quick city ride, daily taxi services, long-distance travel, corporate transportation, or an airport transfer, S9 Travels offers tailored solutions to meet your specific travel needs. We pride ourselves on offering timely, affordable, and top-quality transportation services with a focus on customer satisfaction.</p>
                                </div>
                         
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12 image-column">
                        <div className="image_block_one">
                            <div className="image-box">
                                
                            
                                <figure className="image image-2"><img src="/images/innova-list3.webp" alt="about-2" /></figure>
                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <Visionn/>
        <Testimonialsabout/>
       </>
    );
}

export default About;
